
import React, { useMemo } from 'react';

import { Link } from 'react-router-dom';

import { useSelector } from 'react-redux';

import Marker from '../../../../components/maps/Marker';

const Stops = ({ branche_id }) => {
    const routes = useSelector(state => state.routes.all.data)

    const stops = useMemo(() => {

        return Object.values(routes).reduce((acc, { documentId,  activities = [] }) => {
            activities.forEach(({ pickup_coordinates, activity_status, sequence, customer_name, customer_second_name, expected_arival, customer_number, invoice_number, is_manual, customer_street_number, customer_postalcode, customer_city }) => {

                let color = '';
                let label_color = '#ffffff';
                switch(activity_status) {

                    case 'driving_paused':
                    case 'driving_resumed':
                    case 'driving':
                    case 'arrived_paused':
                    case 'arrived_resumed':
                    case 'arrived':
                        color = '#eaa14a';
                        label_color = '#343434';
                        break;
                    
                    case 'done':
                        color = '#a0c876';
                        label_color = '#343434';
                        break;
                    
                    case 'new':
                    default:
                        color = '#57004e';
                }

                acc.push({
                    route_id: documentId,
                    color: color,
                    label_color: label_color,
                    activity_status: activity_status,
                    pickup_coordinates: pickup_coordinates,
                    sequence: sequence,
                    customer_name: customer_name,
                    customer_second_name: customer_second_name,
                    expected_arival: expected_arival,
                    customer_number: customer_number,
                    invoice_number: invoice_number,
                    is_manual: is_manual,
                    customer_street_number: customer_street_number,
                    customer_postalcode: customer_postalcode,
                    customer_city: customer_city
                });
            
            });

            return acc;
        }, []);

    }, [ routes ]);

    return (
        <>
            {
                stops.map((stop, index) => {
                    const { route_id, pickup_coordinates, color, label_color, sequence, customer_name, customer_second_name, expected_arival, customer_number, invoice_number, is_manual, customer_street_number, customer_postalcode, customer_city } = stop;
                    const label = '';
                    return (
                        <React.Fragment key={index}>
                            <Marker
                                hideZoomLevel={12}
                                position={{
                                    latitude: pickup_coordinates?.coordinates[1],
                                    longitude: pickup_coordinates?.coordinates[0]
                                }}
                                icon={{ fillColor: color, scale: 1 }}
                                infoWindowContent={
                                    
                                    <div className='infowindow'>
                                        <span className='name'>{(sequence && sequence !== 999 ? sequence + '. ' : '')} { customer_name }</span><br />
                                        {
                                            customer_second_name
                                            &&
                                            <><span className='second_name'>{ customer_second_name }</span><br /><br /></>
                                        }
                                        <span className='line'>Venster: <span className='bold'>{ expected_arival }</span></span><br /><br />

                                        <span className='line'>Klantnr: <span className='bold'>{ customer_number }</span></span><br />
                                        <span className='line'>Factuurnummer: <span className='bold'>{ invoice_number }</span></span><br /><br />

                                        { is_manual && <><span className='line'>Handmatig ingevoerd</span><br /><br /></>}
                                        
                                        { customer_street_number }<br />
                                        { customer_postalcode } { customer_city }<br /><br />
                                        <Link to={'/groothandels/' + branche_id + '/routes/' + route_id}>Naar route</Link>
                                    </div>
                                    
                                }
                                label={label}
                                label_color={label_color}
                            />
                        </React.Fragment>
                    )
                })
            }
        
            
        </>
    );
}

export default Stops;